import script from "./AssessList.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessList.vue?vue&type=script&setup=true&lang=js"

import "./AssessList.vue?vue&type=style&index=0&id=a9f496a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9f496a0"]])

export default __exports__